import { Text } from "../../../design/text";
import { Heading, Subheading } from "../../../design/heading";
import { Conversation } from "../../../models/Conversation";
import { cn } from "../../../utils/utils";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
} from "../../../design/dropdown";
import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";
import moment from "moment";

interface ConversationHeaderViewProps {
  conversation: Conversation;
  className?: string;
}

const ConversationHeaderView: React.FC<ConversationHeaderViewProps> = ({
  conversation,
  className,
}) => {
  return (
    <div
      className={cn(
        "flex items-center justify-between w-full border-b pb-2",
        className,
      )}
    >
      <div className="flex flex-col space-y-1">
        <Heading level={2}>{conversation.subject}</Heading>
        <div className="flex items-center space-x-2">
          <Subheading>With</Subheading>
          {conversation.users?.map((user) => (
            <Subheading>{user.name}</Subheading>
          ))}
        </div>
        <Text>Last updated {moment(conversation.updatedAt).fromNow()}</Text>
      </div>

      <Dropdown>
        <DropdownButton>
          <EllipsisHorizontalIcon className="w-5 h-5" />
        </DropdownButton>
        <DropdownMenu>
          <DropdownSection>
            <DropdownItem onClick={() => console.log("Archive")}>
              Archive
            </DropdownItem>
            <DropdownItem onClick={() => console.log("Delete")}>
              Delete
            </DropdownItem>
          </DropdownSection>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default ConversationHeaderView;
